import React from "react";
import ListItem from "@mui/material/ListItem";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { FormattedAmount } from "vino/core";
import { setShipping } from "store/vino/checkoutSlice";

const DeliveryMethodListItem = ({ deliveryMethod }) => {
	const dispatch = useDispatch();
	const shipping = useSelector((state) => state.vino.checkout.shipping);
	const { setValue } = useFormContext();

	const handleSelect = (rate) => {
		dispatch(
			setShipping({
				...rate,
				carrierType: deliveryMethod.carrierType,
				serviceId: rate.rateClassId,
			})
		);
		setValue("shippingMethod", rate.rateClassId, { shouldValidate: true });
	};

	if (deliveryMethod && deliveryMethod.rates) {
		return (
			<>
				{deliveryMethod.rates.map((rate, index) => (
					<div key={index}>
						<ListItem
							dense
							button
							onClick={(ev) => {
								ev.preventDefault();
								handleSelect(rate);
							}}
						>
							<div className="px-10 py-10 ml-0 flex w-full justify-between justify-items-center">
								{shipping && shipping.serviceId === rate.rateClassId ? (
									<Icon
										color="secondary"
										className="fa-solid fa-circle-check"
									/>
								) : (
									<Icon color="action" className="fa-solid fa-circle" />
								)}
								<div className="flex flex-1 flex-col relative overflow-hidden px-8">
									<Typography className="font-bold">
										{renderHTML(rate.serviceName)}
									</Typography>
									<Typography color="textSecondary">
										{renderHTML(rate.description)}
									</Typography>
								</div>

								<div className="flex -mx-2">
									<FormattedAmount
										className="font-semibold"
										value={rate.rate}
									/>
								</div>
							</div>
						</ListItem>
						<Divider className="" />
					</div>
				))}
			</>
		);
	}
	return null;
};

export default DeliveryMethodListItem;

const renderHTML = (rawHTML) =>
	React.createElement("span", { dangerouslySetInnerHTML: { __html: rawHTML } });
